import React, { useState, useEffect, Fragment } from "react";
import "./_login.scss";
import "react-phone-number-input/style.css";
import { toast } from 'react-toastify';
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import { dataService } from "../../Utility/dataService";

export default function LoginForm(props) {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [ischecked, setIschecked] = useState(false);
  const [loader, setLoader] = useState(false);
  const [inputValue, setInputValue] = useState({
    userName: "",
    userDesignation: "",
    companyName: "",
    workEmail: "",
    // phoneNumber: '',
  });

  const [errors, setErrors] = useState({
    userName: "",
    userDesignation: "",
    companyName: "",
    workEmail: "",
    phoneNumber: '',
  });

  const handleChangeInput = (e) => {
    const { name, value } = e.target;

    setInputValue({
      ...inputValue,
      [name]: value,
    });
  };

  const validate = () => {
    let hasError = false;

    if (!inputValue.userName) {
      toast.error('User Name is required');
      hasError = true;
    }
    if (!inputValue.userDesignation) {
      toast.error('User Designation is required');
      hasError = true;
    }
    if (!inputValue.companyName) {
      toast.error('Company Name is required');
      hasError = true;
    }
    if (!inputValue.workEmail) {
      toast.error('Work Email is required');
      hasError = true;
    } else if (!/\S+@\S+\.\S+/.test(inputValue.workEmail)) {
      toast.error('Email address is invalid');
      hasError = true;
    }
    if (!phoneNumber) {
      toast.error('Phone Number is required');
      hasError = true;
    } else if (!/^\+?\d{1,4}?[\s.-]?\(?\d{1,4}?\)?[\s.-]?\d{1,4}[\s.-]?\d{1,4}[\s.-]?\d{1,9}$/.test(phoneNumber)) {
      toast.error('Phone Number must be 10 digits');
      hasError = true;
    }
    return !hasError;
  };
  console.log('isChecked', ischecked)
  const handleSubmit = (e) => {
    // e.preventDefault();
    setLoader(true)
    if (validate()) {
      const req = {
        "fname": inputValue.userName,
        "designation": inputValue.userDesignation,
        "comapny": inputValue.companyName,
        "email": inputValue.workEmail,
        "mobile": phoneNumber,
        'msg': ''
      };
  
      let response = dataService.SubmitUserData(req);
      response
        .then((res) => {
          if (res?.isSuccess === true) {
            toast.success('Form Submitted successfully!');
            setInputValue({
              userName: '',
              userDesignation: '',
              companyName: '',
              workEmail: '',
              phoneNumber: '',
            });
            setLoader(false)
          } else {
            setInputValue({
              userName: '',
              userDesignation: '',
              companyName: '',
              workEmail: '',
              phoneNumber: '',
            });
            setLoader(false)
          }
        })
        .catch((error) => {
          setLoader(false)
          console.log("Error while fetching cards", error);
        });
    }
    else{
      setLoader(false)
      setIschecked(false)
    }
  };

  

  return (
    <Fragment>
      <div className="row">
        <div className="col-12 mb-4">
          {/* <label className="form-label roboto-medium">Name</label> */}
          <input
            type="text"
            name="userName"
            value={inputValue.userName}
            className="form-control"
            onChange={(e) => handleChangeInput(e)}
            placeholder="Enter your name"
          />
        </div>
        <div className="col-12 mb-4">
          {/* <label className="form-label roboto-medium">Designation</label> */}
          <input
            type="text"
            name="userDesignation"
            value={inputValue.userDesignation}
            className="form-control"
            onChange={(e) => handleChangeInput(e)}
            placeholder="Enter your Designation"
          />
        
        </div>
        <div className="col-12 mb-4">
          {/* <label className="form-label roboto-medium">Company</label> */}
          <input
            type="text"
            name="companyName"
            value={inputValue.companyName}
            className="form-control"
            onChange={(e) => handleChangeInput(e)}
            placeholder="Enter your Company Name"
          />
        </div>
        <div className="col-12 mb-4">
          {/* <label className="form-label roboto-medium">Work Email</label> */}
          <input
            type="email"
            name="workEmail"
            value={inputValue.workEmail}
            className="form-control"
            onChange={(e) => handleChangeInput(e)}
            placeholder="Enter your work email"
          />
        </div>
        <div className="col-12 mb-3">
          {/* <label className="form-label roboto-medium">Contact No.</label> */}
          <PhoneInput
            defaultCountry="IN"
            name="phoneNumber"
            value={inputValue.phoneNumber}
            onChange={setPhoneNumber}
            placeholder={`Enter Contact No.`}
          />
        </div>

        <div className="col-12 mb-3">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              // value={ischecked}
              onChange={() => setIschecked(!ischecked)}
              id="flexCheckDefault"
              checked={ischecked}
            />
            <label className="form-check-label" htmlFor="flexCheckDefault">
              I'd like to learn more about Easyrewardz products and services.
              Call me.
            </label>
          </div>
        </div>
        <div className="col-12 mb-2 text-center">
          <button
            className={`btn btn-submit w-100 d-flex gap-3 justify-content-center align-items-center roboto-medium ${loader ? 'disabled' : ''}`} 
            disabled={!ischecked}
            onClick={() => handleSubmit()}>
            SUBMIT  {loader && <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>} 
            
          </button>
        </div>
      </div>
    </Fragment>
  );
}
